import { tickerItems } from '@/mocks/site';

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <section aria-label="最新快讯" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-content items-center gap-4 px-4 md:px-6 py-3">
        <span className="flex shrink-0 items-center gap-2 rounded-sm bg-primary-500 px-3 py-1 text-xs font-bold tracking-wider text-background-50">
          <i className="ri-flashlight-fill"></i>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track whitespace-nowrap">
            {loop.map((text, index) => (
              <span key={`${text}-${index}`} className="mx-6 inline-flex items-center text-sm text-foreground-700">
                <i className="ri-message-2-line mr-2 text-secondary-500"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}